export default __webpack_public_path__ + "static/media/default_avatar.57d298a9.jpg";